module.exports = __webpack_public_path__ + "static/img/float_icon_a.17ac46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/float_icon_a.png
// module id = Kiim
// module chunks = 78